import { useFormikWrapper } from "../../../components/formik_wrapper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';
import ConfigMigration from './components/migration_configuration_template'
import ModuleSelected from './components/module_selection_template'
import MigrationStatus from './components/migration_status_template'
import validationSchema from "./util/validation-schema";
import * as actions from "../../../../src/actions/index";
export default function CreateMigration() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { migration_uid, currentModule } = useParams();
  const [step, setStep] = useState("config");
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [currentMigID, setCurrentMigID] = useState();
  const [selectedConfigFields, setselectedConfigFields] = useState([]);

  const configMigrationFormik = useFormikWrapper({
    initialValues: {
      from_company_region: "",
      from_company_uid: "",
      from_company_name: "",
      from_api_key: "",
      to_company_region: "",
      to_company_uid: "",
      to_company_name: "",
      to_api_key: "",
      migration_type: "CONFIG",
      isDataMigrationEnabled: false,
      from_company_ref_date: "",
      cloneAccount : "None",
      isFromSourceAccount : false,
      regionObjectList:[]
    },
    initialErrors: false,
    validationSchema: validationSchema.migrationConfigSchema,
    onSubmit: () => { },
  });

  useEffect(() => {
    if (migration_uid) {
      if (currentModule == "configuration") {
        setCurrentMigID(migration_uid)
        setStep("config")
        setIsReadOnly(true)
      }
      else if (currentModule == "modules") {
        setCurrentMigID(migration_uid)
        setStep("selectTemplate")
        setIsReadOnly(true)
      }
      else if (currentModule == "status") {
        setCurrentMigID(migration_uid)
        setStep("configStatus")
        setIsReadOnly(true)
      }
    }
  }, [currentModule])

  useEffect(() => {
    configMigrationFormik.resetForm()
  }, [])

  // 0 - Not started : Empty gray circle
  // 1 - In Progress :  Green circle
  // 2 - Completed : Green tick
  const listSvg = {
    0: <span className="flex h-9 items-center" ariaHidden="true">
      <span
        className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
        <span className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"></span>
      </span>
    </span>,
    1: <span className="flex h-9 items-center" aria-hidden="true">
      <span
        className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-green-600 bg-white">
        <span className="h-2.5 w-2.5 rounded-full bg-green-600"></span>
      </span>
    </span>,
    2: <span className="flex h-9 items-center">
      <span
        className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-green-600 group-hover:bg-green-800">
        <svg className="h-5 w-5 text-white" viewBox="0 0 20 20"
          fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd"
            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
            clip-rule="evenodd" />
        </svg>
      </span>
    </span>
  }

  return (
    <main className="-mt-24">
      <div className="mx-auto max-w-7xl py-3 sm:px-6 lg:px-8">
        <div className="flex flex-1 space-x-4">
          {/* steppers */}
          {<aside className="w-80 overflow-y-auto rounded-lg shadow self-start sticky top-4">
            <div className="p-6 bg-white">
              <nav aria-label="Progress">
                <ol role="list" className="overflow-hidden">
                  <li className="relative pb-10">
                    <div className={`${(step == "selectTemplate" || step == "configStatus" || isReadOnly) ? "bg-green-600" : "bg-gray-300"} absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5`}
                      aria-hidden="true">
                    </div>
                    <a className="group relative flex items-start cursor-pointer" onClick={() => {
                      if (isReadOnly) {
                        navigate(`/migration/${migration_uid}/configuration`);
                      }
                    }}>
                      {(step == "selectTemplate" || step == "configStatus" || isReadOnly) ? listSvg['2'] : listSvg['1']}
                      <span className="ml-4 flex min-w-0 flex-col">
                        <span className={`text-sm font-medium ${step == "config" ? `` : `text-gray-500`}`}>Configuration</span>
                        <span className="text-sm text-gray-500">Select source and destination
                          accounts</span>
                      </span>
                    </a>
                  </li>
                  <li className="relative pb-10">
                    <div className={`${(step == "configStatus" || isReadOnly) ? "bg-green-600" : "bg-gray-300"} absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5`}
                      aria-hidden="true">
                    </div>
                    <a className="group relative flex items-start cursor-pointer" aria-current="step" onClick={() => {
                      if (isReadOnly) {
                        navigate(`/migration/${migration_uid}/modules`);
                      }
                    }}>
                      {(step == "configStatus" || isReadOnly) ? listSvg['2'] : step == "selectTemplate" ? listSvg['1'] : listSvg['0']}
                      <span className="ml-4 flex min-w-0 flex-col">
                        <span className={`text-sm font-medium ${step == "selectTemplate" ? `` : `text-gray-500`}`}>Module Selection</span>
                        <span className="text-sm text-gray-500">Choose the modules to migrate</span>
                      </span>
                    </a>
                  </li>
                  <li className="relative ">
                    <div className={`${isReadOnly ? "bg-green-600" : "bg-gray-300"} absolute left-4 top-4 -ml-px mt-0.5 h-full`}
                      aria-hidden="true">
                    </div>
                    <a className="group relative flex items-start cursor-pointer" onClick={() => {
                      if (isReadOnly) {
                        navigate(`/migration/${migration_uid}/status`);
                      }
                    }}>
                      {(isReadOnly) ? listSvg['2'] : step == "configStatus" ? listSvg['1'] : listSvg['0']}
                      <span className="ml-4 flex min-w-0 flex-col">
                        <span className={`text-sm font-medium ${step == "configStatus" ? `` : `text-gray-500`}`}>Migration Status</span>
                        <span className="text-sm text-gray-500">View the current status</span>
                      </span>
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
          </aside>}
          {/* main pages */}
          {step == 'config' ? <ConfigMigration setStep={setStep} formik={configMigrationFormik} isReadOnlyView={isReadOnly} currentMigID={currentMigID}></ConfigMigration> : step === "selectTemplate" ? <ModuleSelected setStep={setStep} formik={configMigrationFormik} setCurrentMigID={setCurrentMigID} isReadOnlyView={isReadOnly} currentMigID={currentMigID} setselectedConfigFields={setselectedConfigFields}></ModuleSelected> : <MigrationStatus isReadOnlyView={isReadOnly} currentMigID={currentMigID} selectedConfigFields={selectedConfigFields} formik={configMigrationFormik}></MigrationStatus>}
        </div>
      </div>
    </main>
  )
}